import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(({ theme }) => ({
    root: {
        width: '100%',
        marginBottom: '20px',
    },
    txtSearchProgram: {
        width: '100%',
        marginBottom: '24px',
        fontWeight: 500,
        fontSize: '1rem',
    },
    filtersHeaderTitle: {
        height: '16px',
        padding: '16px',
        fontSize: '1rem',
        fontWeight: 700,
        backgroundColor: '#FFF',
        color: '#333',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 0px 16px rgba(115, 146, 178, 0.25)',
        borderRadius: '4px 4px 0px 0px',
    },
    filterSection: {
        margin: 0,
    },
    filterSectionHeader: {
        height: '16px',
        lineHeight: '1rem',
        backgroundColor: '#FFF',
        color: '#617080',
        fontSize: '0.875rem',
        fontWeight: '400',
        padding: '12px 16px',
        boxShadow: '0px 0px 16px rgba(115, 146, 178, 0.25)',
    },
    filterSectionContent: {
        padding: 0,
        margin: 0,
        backgroundColor: '#EBEFF5',
        boxShadow: '0px 0px 16px rgba(115, 146, 178, 0.25)',
        display: 'flex',
        flexDirection: 'column',
    },
    txtSearchFilterOptions: {
        margin: '8px 8px 0 8px',
        height: '32px',
        borderRadius: '25px',
        fontSize: '0.875rem',
    },
    lstFilterOptions: {
        height: 'unset',
        maxHeight: '128px',
        padding: '8px',
        margin: 0,
        overflowY: 'auto',
        listStyle: 'none',
        '& li': {
            marginBottom: '8px',
            padding: '0 0 0 4px',
            textAlign: 'left',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.875rem',
        },
        '& li:last-child': {
            marginBottom: 0,
        },
    },
}));